export const partners = [
  {
    id: "1",
    name: "Гранд Отель Европа",
    type: "Отель",
    description: "Пятизвёздочный отель в центре города с 120 номерами. Работаем с нами с 2023 года.",
    reviewText: "Have Received подобрали нам идеальную команду на ресепшен. Гости стали чаще отмечать профессионализм персонала в отзывах. Рекомендуем!",
    stars: 5,
    reviewDate: "2025-03-15",
    avatarUrl: "/readdy/bff5879ef9fc79f527e457a7c2d06b75.png",
  },
  {
    id: "2",
    name: "Санаторий Золотые Пески",
    type: "Санаторий",
    description: "Оздоровительный комплекс на берегу моря. 200+ номеров и полный пансион.",
    reviewText: "Благодаря обучению от Have Received наши администраторы теперь справляются с пиковой загрузкой в сезон без сбоев. Отличный сервис.",
    stars: 5,
    reviewDate: "2025-02-28",
    avatarUrl: "/readdy/bee3efbbdfd439dd4ae76a783e6827ef.png",
  },
  {
    id: "3",
    name: "Хостел ArtCapsule",
    type: "Хостел",
    description: "Арт-хостел с уникальной творческой концепцией. 40 мест, коворкинг и галерея.",
    reviewText: "Для нашего арт-хостела важны особые люди — Have Received нашли именно таких. Гости обожают нашу атмосферу!",
    stars: 5,
    reviewDate: "2025-01-20",
    avatarUrl: "/readdy/4c4bd2a415738a41528f253b047cd1c1.png",
  },
  {
    id: "4",
    name: "Пансионат Берёзовая Роща",
    type: "Пансионат",
    description: "Уютный пансионат за городом. 60 номеров, собственный парк и ресторан.",
    reviewText: "Внедрили CRM по рекомендации Have Received — теперь учёт клиентов ведётся идеально. Администраторы работают в единой системе.",
    stars: 5,
    reviewDate: "2025-04-10",
    avatarUrl: "/readdy/7f522f85c0a236e3ac47554e5aa49304.png",
  },
  {
    id: "5",
    name: "Гостиничный комплекс «Новый Свет»",
    type: "Гостиничный комплекс",
    description: "Современный гостиничный комплекс с двумя корпусами. 180 номеров, конференц-залы и spa.",
    reviewText: "После обучения администраторов от Have Received время регистрации сократилось вдвое. Клиенты довольны скоростью заселения.",
    stars: 4,
    reviewDate: "2025-03-05",
    avatarUrl: "/readdy/a74e7dcf14452b0e70983177b093e093.png",
  },
  {
    id: "6",
    name: "Отель Ривьера",
    type: "Отель",
    description: "Бутик-отель на набережной. 35 уникальных номеров с панорамным видом.",
    reviewText: "Have Received не только нашли нам идеальных админов, но и настроили CRM. Теперь мы знаем каждого гостя лично.",
    stars: 5,
    reviewDate: "2025-04-22",
    avatarUrl: "/readdy/d80a7e04e09fa98dc7e2689db33a01d2.png",
  },
  {
    id: "7",
    name: "Санаторий Подольск",
    type: "Санаторий",
    description: "Медицинский санаторий с диагностической базой. 150 номеров.",
    reviewText: "Работаем по СМК — Have Received обучили весь персонал стандартам. Проверки проходим на отлично.",
    stars: 5,
    reviewDate: "2025-02-10",
    avatarUrl: "/readdy/7a00ac3f3d209014ecaed6dfb716f15d.png",
  },
  {
    id: "8",
    name: "Хостел R.E.d.",
    type: "Хостел",
    description: "Стильный молодёжный хостел в центре города. 50 мест, собственный бар и роoftop.",
    reviewText: "Думали, что для хостела качественный персонал — роскошь. Have Received доказали обратное. Спасибо!",
    stars: 4,
    reviewDate: "2025-01-05",
    avatarUrl: "/readdy/c038b77903b5424b1b073de1bad789b0.png",
  },
  {
    id: "9",
    name: "Пансионат «Приветливый берег»",
    type: "Пансионат",
    description: "Семейный пансионат на берегу реки. 90 номеров, пляж и детская зона.",
    reviewText: "Нашли администраторов, которые по-настоящему любят работать с семьями. Гости это чувствуют и возвращаются.",
    stars: 5,
    reviewDate: "2025-03-28",
    avatarUrl: "/readdy/fe142a8f21ef1ba3fe5d4ef32695b3c2.png",
  },
  {
    id: "10",
    name: "Гостиница Центральная",
    type: "Гостиница",
    description: "Историческая гостиница с современным ремонтом. 100 номеров, ресторан высокой кухни.",
    reviewText: "Полный пакет услуг — подбор, обучение, CRM. Have Received стали нашим надёжным партнёром на годы вперёд.",
    stars: 5,
    reviewDate: "2025-04-01",
    avatarUrl: "/readdy/3c55fdb3f3fb11f0ccd319be95c4795c.png",
  },
  {
    id: "11",
    name: "Отель Скандинавия",
    type: "Отель",
    description: "Современный отель в скандинавском стиле. 55 номеров, SPA и фитнес.",
    reviewText: "Цифровизация процессов по СМК от Have Received превзошла ожидания. Всё работает чётко и прозрачно.",
    stars: 4,
    reviewDate: "2025-02-15",
    avatarUrl: "/readdy/10b18d79ad8a9d8df7202036089114bd.png",
  },
  {
    id: "12",
    name: "Санаторий «Виктория»",
    type: "Санаторий",
    description: "Премиум санаторий с полным комплексом оздоровительных программ. 180 номеров.",
    reviewText: "Обучили весь административный персонал работе с гостями. Уровень сервиса вырос заметно — благодарим!",
    stars: 5,
    reviewDate: "2025-04-18",
    avatarUrl: "/readdy/79f875d1ee070811a119bc709b7ce7ec.png",
  },
];